module.exports = __webpack_public_path__ + "static/media/traycorp6.c946ead0.png";